<template>
  <div class="video__wrapper">
    <video
      ref="video"
      class="video__element"
      loop
      muted=""
      playsinline=""
      disableRemotePlayback
      preload="none"
      width="100%"
      :style="{ 'background-image': `url(${poster})` }"
    >
      <source
        v-for="source in sources"
        :key="source.url"
        :src="source.url"
        :type="source.mimeType"
      />
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
export default {
  name: "Video",
  props: {
    video: {
      type: Object,
      required: true,
    },
    intersected: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    sources() {
      return this.video.sources;
    },
    poster() {
      if (this.video.previewImage) {
        return this.video.previewImage.url;
      }
      return null;
    },
  },
  watch: {
    intersected(newVal, oldVal) {
      if (oldVal === false && newVal === true) {
        this.playVideo();
      }
    },
  },
  mounted() {
    if (this.intersected) {
      this.playVideo();
    }
  },
  methods: {
    async playVideo() {
      try {
        await this.$refs["video"].play();
      } catch (error) {
        console.warn(error);
        this.$refs["video"].setAttribute("controls", true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.video__wrapper {
  height: 100%;
}

.video__element {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center center;
}
</style>
